import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DoneIcon from '@mui/icons-material/Done';
import { getRandomCoins } from '../../utils/helper';
import DeveloperInfo from '../common/DeveloperInfo';
import { SOLVING_METHODS, URLS } from '../../constants/appConstants';
import { getCoinsIcon } from '../common/simpleComponents';
// import {URLS} from '../constants/appConstants';
import { useNavigate } from 'react-router-dom';
import SendIcon from '@mui/icons-material/Send';
import { Alert } from '@mui/material';

export default function SolveQuestionDialog({ settings, questionType, handleSubmitVote, setSolvingMethod, initialSolve = false, incompleteText = '',
  solveButtonText = 'Solve',
}) {
  const [open, setOpen] = React.useState(initialSolve);
  const [insufficientBalance, setInsufficientBalance] = React.useState(false);
  const navigate = useNavigate();
  const isSolve = solveButtonText === 'Solve';

  const handleClickOpen = () => {
    setOpen(true);
  };

  // React.useEffect(() => {
  //   setOpen(settings.solveQuestion)
  // }, [settings.solveQuestion])

  const handleClose = (solvingMethod) => {
    setOpen(false);
    setSolvingMethod(solvingMethod)
    handleSubmitVote()
  };

  console.log("settings2", settings);

  const getIcon = () => {
    if (isSolve) {
      return <DoneIcon />
    }
    return <SendIcon />
  }
  return (
    <React.Fragment>
      {(settings.solveQuestion === true) && <Button variant={isSolve ? 'outlined' : 'contained'} endIcon={getIcon()} onClick={handleClickOpen}>
      {solveButtonText}
      </Button>}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="solve-q-dialog-title"
        aria-describedby="solve-q-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {solveButtonText}
        </DialogTitle>
        <DeveloperInfo>
          Solving questions using coins/Ads is considered as "unresolved".
          <br />
          <Button onClick={() => setInsufficientBalance(!insufficientBalance)}> Toggle sufficient balance</Button>
        </DeveloperInfo>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <>{incompleteText && 
            <Alert severity="error">{incompleteText}.</Alert>
            }</>
            Do you want to Solve this {questionType} using 10 coins? You've {' '}
            <b>{insufficientBalance ? '2' : getRandomCoins()} coins </b>
            left in your wallet.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          {insufficientBalance ? <Button onClick={() => navigate(URLS.BUY_COINS)} variant={'contained'} endIcon={getCoinsIcon()}>
            Buy coins
          </Button> : <Button onClick={() => handleClose(SOLVING_METHODS.COINS)} variant={'contained'} endIcon={getCoinsIcon()}>
            10 coins
          </Button>}


        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
